import React from 'react'

const Card = ({
  id=false,
  children,
  className,
}) => {
  return (
    <>
      {id ? (
        <div id={id} className={`rounded-lg shadow-md ${className}`}>
          {children}
        </div>
      ) : (
        <div className={`rounded-lg shadow-md ${className}`}>
          {children}
        </div>
      )}
    </>
  )
}

export default Card